import { Link } from '@tanstack/react-router'
import type { BadgeTone } from '@/components/ui'
import type { Entity } from '@/lib/types'
import { Avatar, Row } from '@/components/ui'
import { entitySlug } from '@/lib/helpers'

interface EntityChipProps {
  entity: Entity
  /** When set, renders a stacked label above the name (large display). */
  label?: string
  size?: number
  tone?: BadgeTone
  ring?: boolean
}

export default function EntityChip({
  entity,
  label,
  size = 36,
  tone = 'emerald',
  ring = false,
}: EntityChipProps) {
  return (
    <Link
      to="/communautes/$slug"
      params={{ slug: entitySlug(entity.id, entity.name) }}
      style={{
        textDecoration: 'none',
        color: 'inherit',
        display: 'inline-flex',
      }}
    >
      <Row gap="md" style={{ alignItems: 'center' }}>
        <Avatar
          name={entity.name}
          tone={tone}
          size={size}
          ring={ring}
          imageUrl={entity.image_uri}
        />
        {label ? (
          <div>
            <div style={{ fontSize: 13, color: 'var(--ink-3)' }}>{label}</div>
            <div
              style={{ fontSize: 16, fontWeight: 600, color: 'var(--ink-1)' }}
            >
              {entity.name}
            </div>
          </div>
        ) : (
          <span
            style={{
              fontWeight: 600,
              color: 'var(--ink-1)',
              fontSize: Math.round(size * 0.38 + 2),
            }}
          >
            {entity.name}
          </span>
        )}
      </Row>
    </Link>
  )
}
